import React from 'react';
import { Menu, X } from 'lucide-react';

interface NavigationProps {
  currentSection: string;
  setCurrentSection: (section: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ currentSection, setCurrentSection }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const sections = [
    { id: 'home', label: 'Home', formula: '⌂' },
    { id: 'about', label: 'About', formula: '∫' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white bg-opacity-90 backdrop-blur-sm z-50 border-b border-beige-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <span className="text-2xl font-bold text-gray-900 font-math">
              Amit Tomar
            </span>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setCurrentSection(section.id)}
                className={`flex items-center space-x-2 px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                  currentSection === section.id
                    ? 'text-beige-700 border-b-2 border-beige-500'
                    : 'text-gray-600 hover:text-beige-700'
                }`}
              >
                <span className="font-math">{section.formula}</span>
                <span>{section.label}</span>
              </button>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-beige-700 focus:outline-none"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => {
                    setCurrentSection(section.id);
                    setIsMenuOpen(false);
                  }}
                  className={`flex items-center space-x-2 w-full px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                    currentSection === section.id
                      ? 'text-beige-700 bg-beige-100'
                      : 'text-gray-600 hover:text-beige-700 hover:bg-beige-50'
                  }`}
                >
                  <span className="font-math">{section.formula}</span>
                  <span>{section.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
